import {
  Toolbar,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  ExportCsv,
  ToolbarButton,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
} from '@mui/x-data-grid';
import { Box, Button, IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import { Clear, FileDownload, FilterList, Search, ViewWeek } from '@mui/icons-material';
import WordWrapButton from './WordWrapButton';

const CustomToolbar = ({
  children,
  toolbarOptions,
  handleMenuClick,
  csvOptions,
  quickFilterValue = '',
  filterMode = 'client', // default to client
  onQuickFilterChange,
}) => {
  const columnOption = toolbarOptions.includes('COLUMNS');
  const filterOption = toolbarOptions.includes('FILTER');
  const densityOption = toolbarOptions.includes('DENSITY');
  const exportOption = toolbarOptions.includes('EXPORT');
  const searchOption = toolbarOptions.includes('SEARCH');
  const isFilterOption = columnOption || filterOption || densityOption || exportOption;

  return (
    <Toolbar sx={{ minHeight: 'auto', width: '100%', px: 1, py: 0, mt: 1, borderBottom: 0 }}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box
          sx={{
            minWidth: 0,
            flex: '1 1 auto',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {(isFilterOption || children) && (
            <Stack
              direction='row'
              spacing={1}
              useFlexGap
              sx={{
                flexWrap: 'wrap',
                alignItems: 'center',

                '& .MuiButton-root': {
                  width: 'auto',
                  minWidth: 'fit-content',
                  whiteSpace: 'nowrap',
                },
              }}
            >
              {columnOption && (
                <ColumnsPanelTrigger
                  render={
                    <ToolbarButton
                      render={
                        <Button size='small' startIcon={<ViewWeek />}>
                          Columns
                        </Button>
                      }
                    />
                  }
                />
              )}
              {filterOption && (
                <FilterPanelTrigger
                  render={
                    <ToolbarButton
                      render={
                        <Button size='small' startIcon={<FilterList />}>
                          Filter
                        </Button>
                      }
                    />
                  }
                />
              )}
              {densityOption && <WordWrapButton handleMenuClick={handleMenuClick} />}
              {exportOption && (
                <ExportCsv
                  options={csvOptions}
                  render={
                    <ToolbarButton
                      render={
                        <Button size='small' startIcon={<FileDownload />}>
                          Export
                        </Button>
                      }
                    />
                  }
                />
              )}
              {children}
            </Stack>
          )}
        </Box>

        {searchOption && (
          <Box
            sx={{
              minWidth: 0,
              width: { xs: '100%', sm: 240, md: 260 },
              ml: { md: 'auto' },
              flex: { xs: '1 1 100%', md: '0 0 auto' },
            }}
          >
            {filterMode === 'server' ? (
              <TextField
                fullWidth
                size='small'
                placeholder='Search...'
                variant='standard'
                value={quickFilterValue}
                onChange={e => onQuickFilterChange(e)}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Search fontSize='small' />
                      </InputAdornment>
                    ),
                    endAdornment: quickFilterValue !== '' && (
                      <InputAdornment position='end'>
                        <IconButton size='small' onClick={() => onQuickFilterChange({ target: { value: '' } })}>
                          <Clear fontSize='small' />
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            ) : (
              <QuickFilter
                render={(props, state) => (
                  <QuickFilterControl
                    {...props}
                    render={({ slotProps, size, ...controlProps }) => (
                      <TextField
                        size='small'
                        placeholder='Search...'
                        variant='standard'
                        {...controlProps}
                        {...slotProps?.htmlInput}
                        slotProps={{
                          input: {
                            startAdornment: (
                              <InputAdornment position='start'>
                                <Search fontSize='small' />
                              </InputAdornment>
                            ),
                            endAdornment:
                              state.value !== '' ? (
                                <InputAdornment position='end'>
                                  <QuickFilterClear
                                    render={
                                      <IconButton size='small'>
                                        <Clear fontSize='small' />
                                      </IconButton>
                                    }
                                  />
                                </InputAdornment>
                              ) : null,
                          },
                        }}
                        sx={{ width: '100%' }}
                      />
                    )}
                  />
                )}
              />
            )}
          </Box>
        )}
      </Box>
    </Toolbar>
  );
};

export default CustomToolbar;
